import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as GlobalFooterAPI from "@/api/sub-menu";
import { CommonResponse, isSuccess } from "@/api/response";
import { SortRequest } from "@/api/sub-menu/request";

const MODULE_NAME = "sub-menu/modify";

/**
 * global-footer情報登録更新APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Modify extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  // MutationActions
  @MutationAction
  async sort(sortRequest: SortRequest) {
    const commonResponse = await GlobalFooterAPI.sort(sortRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Modify);
